module.exports = __webpack_public_path__ + "static/img/emd-alerts.d1ead5ad.png";